<template>
  <span class="relative inline-block">
    <img
      :src="src"
      aria-hidden="true"
      class="pointer-events-none absolute top-11.25 left-1/2 w-[110%] max-w-none"
      :style="{ transform: `translate(-50%, -50%) rotate(${rotate}deg)` }"
    />
    <span class="relative">
      <slot />
    </span>
  </span>
</template>

<script setup lang="ts">
interface Props {
  src: string
  rotate?: number | string
}

withDefaults(defineProps<Props>(), {
  rotate: 0,
})
</script>
